import { Inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { UnespCoreEnvironment } from 'src/libs/unesp-core'
import { identity, Observable } from 'rxjs'
import { ErrorHandlerService } from './error-handler.service'

export interface IdentificaProcesso {
  identificador: string
  editais: string[]
}

export interface IdentificaResponse {
  processos: IdentificaProcesso[]
}

export interface ErroFoto {
  inscricaoId: number
  mensagem: string
}

export interface ResultadoEnvioResponse {
  message: string
  sucesso: boolean
  totalSolicitado?: number
  totalEncontrado?: number
  candidatosEnviados?: number
  fotosEnviadas?: number
  falhasEnvioFoto?: number
  errosFotos?: ErroFoto[]
}

export interface ResultadoBuscaResponse {
  message: string
  sucesso: boolean
  identificadorProcesso?: string
}

@Injectable({
  providedIn: 'root',
})
export class HeteroidentificacaoService {
  private baseUrl: string

  constructor(
    private http: HttpClient,
    private errorHandlerService: ErrorHandlerService,
    @Inject('environment') env: UnespCoreEnvironment
  ) {
    this.baseUrl = env.baseUrlApi
  }

  buscarIdentificadores(identificador: string): Observable<IdentificaResponse> {
    return this.http
      .get<IdentificaResponse>(`${this.baseUrl}/identifica/processos/identificadores`, {
        params: { identificador }
      })
      .pipe(identity, this.errorHandlerService.catchError())
  }

  registrarHeteroidentificacao(idConcurso: number, processoHeteroidentificacao: string, editalHeteroidentificacao: string): Observable<any> {
    return this.http
      .put<any>(`${this.baseUrl}/concurso/${idConcurso}/heteroidentificacao`, {
        processoHeteroidentificacao,
        editalHeteroidentificacao
      })
      .pipe(identity, this.errorHandlerService.catchError())
  }

  enviarCandidatos(idConcurso: number): Observable<ResultadoEnvioResponse> {
    return this.http
      .post<ResultadoEnvioResponse>(`${this.baseUrl}/identifica/submete-inscricao`, null, {
        params: { idConcurso: idConcurso.toString() }
      })
      .pipe(identity, this.errorHandlerService.catchError())
  }

  buscarResultados(idConcurso: number): Observable<ResultadoBuscaResponse> {
    return this.http
      .get<ResultadoBuscaResponse>(`${this.baseUrl}/identifica/resultado/${idConcurso}`)
      .pipe(identity, this.errorHandlerService.catchError())
  }
}
